import { render, staticRenderFns } from "./ViewUploadFile.vue?vue&type=template&id=34cb6363&"
import script from "./ViewUploadFile.vue?vue&type=script&lang=js&"
export * from "./ViewUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports